export default "__VITE_ASSET__C2zOb$Y8__"